/* AnnouncementBannerItem.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./AnnouncementBannerItem.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import { Flex } from '@atlaskit/primitives/compiled';
var announcementStyles = {
  default: "_2rkoiti9 _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _bfhk1nvp _syazzjem"
};
export function AnnouncementBannerItem(_ref) {
  var text = _ref.text,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: announcementStyles.default,
    alignItems: "center",
    justifyContent: "space-between",
    gap: "space.050"
  }, text, /*#__PURE__*/React.createElement(IconButton, {
    icon: CloseIcon,
    label: 'Close',
    spacing: "compact",
    appearance: "subtle",
    onClick: onClose
  }));
}